import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { MapMarkerProps } from './types';
import { OverlayView } from '@react-google-maps/api';
import { View } from 'react-native';

const MARKER_SIZE = 12;

export const UserLocationMarker: React.FC<MapMarkerProps> = ({
  coordinate,
}) => {
  const [styles] = useStyles();

  return (
    <OverlayView
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      position={{
        lat: coordinate.latitude,
        lng: coordinate.longitude,
      }}
    >
      <View style={styles.locationMarkerContainer}>
        <View style={styles.marker} />
      </View>
    </OverlayView>
  );
};

const useStyles = createStyles((theme) => ({
  // The pin is rendered at (0, 0) with a height and width of 12,
  // which puts the center of the pin at (6, 6), so we use
  // these negative margins to offset it back to (0, 0)
  locationMarkerContainer: {
    marginLeft: (MARKER_SIZE / 2) * -1,
    marginTop: MARKER_SIZE * -1,
  },
  marker: {
    backgroundColor: theme.colors.mapLocationBlue,
    borderColor: theme.colors.white,
    borderRadius: 6,
    borderWidth: 1.5,
    height: MARKER_SIZE,
    width: MARKER_SIZE,
  },
}));
